import { motion } from "framer-motion";
import { Sparkles } from "lucide-react";

const OurStory = () => {
  return (
    <section id="about" className="py-24 bg-background relative overflow-hidden">
      {/* Background Glow */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-primary/5 rounded-full blur-[150px]" />
      </div>

      <div className="container mx-auto px-6 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="max-w-3xl mx-auto text-center"
        >
          {/* Section Badge */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.1 }}
            viewport={{ once: true }}
            className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary/10 border border-primary/20 mb-8"
          >
            <Sparkles className="w-4 h-4 text-primary" />
            <span className="text-sm font-subtitle text-primary">The Beginning</span>
          </motion.div>

          {/* Title */}
          <h2 className="font-display text-4xl md:text-5xl font-semibold text-foreground mb-10">
            Our <span className="text-primary glow-text">Story</span>
          </h2>

          {/* Story Content */}
          <div className="space-y-6 text-left">
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2 }}
              viewport={{ once: true }}
              className="font-subtitle text-lg text-muted-foreground leading-relaxed"
            >
              Every great journey starts with a single spark. For us, it was a late night conversation with my partner, dreaming out loud about building something meaningful. That night, Alluring Aesthetic was born from a simple but powerful idea: unique makeup that celebrates your individuality.
            </motion.p>

            <motion.p
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.3 }}
              viewport={{ once: true }}
              className="font-subtitle text-lg text-muted-foreground leading-relaxed"
            >
              What started as a dream quickly became a mission. I taught myself to build websites, spent countless hours sourcing the finest products and poured my heart into every detail. Because when you believe in something, you don't just start, you commit.
            </motion.p>

            <motion.p
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.4 }}
              viewport={{ once: true }}
              className="font-subtitle text-lg text-muted-foreground leading-relaxed"
            >
              This isn't just a business. It's proof that dreams become reality when you take that first step. Thank you for being part of our story.
            </motion.p>
          </div>

          {/* Signature/Closing */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.5 }}
            viewport={{ once: true }}
            className="mt-10 pt-8 border-t border-border/50"
          >
            <p className="font-display text-primary text-lg italic">
              With love, The Alluring Aesthetic Team
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default OurStory;
